import { formatNumber } from '@/shared'

export function formatNumberToPercentage(value: number): string {
  return formatNumber(value * 100) + '%'
}
